<div class="mask" *ngIf="visible"></div>
